<template>
  <img class="ui-plan-limits" src="/images/badge-dollar.svg" alt="badge-dollar">
</template>

<script setup lang="ts">
</script>
